import Vue from 'vue';
export const defaultDataFormOptions = {
  requiredByDefault: true,
  immutable: false,
  setter: Vue.set,
  uiResolvers: [
  // 如果选项很少，改进单选框的style
  schema => {
    var _schema$enum;
    const enumLen = (_schema$enum = schema.enum) === null || _schema$enum === void 0 ? void 0 : _schema$enum.length;
    if (enumLen && enumLen <= 4) return {
      type: 'w-radio'
    };
  },
  // 如果使用了 any 类型，则显示 anyEditor
  schema => {
    var _schema$enum2;
    if (!((_schema$enum2 = schema.enum) !== null && _schema$enum2 !== void 0 && _schema$enum2.length) && schema.type === 'any') return {
      type: 'anyInput'
    };
  },
  // 如果是可插值的字符串，则显示 exprInput
  schema => {
    var _schema$enum3;
    if (!((_schema$enum3 = schema.enum) !== null && _schema$enum3 !== void 0 && _schema$enum3.length) && schema.type === 'string' && schema['uc:allowInterop']) {
      var _schema$ui, _schema$ui2;
      return {
        type: 'exprInput',
        props: {
          type: 'interopable-string',
          multipleLine: !!((_schema$ui = schema.ui) !== null && _schema$ui !== void 0 && (_schema$ui = _schema$ui.settings) !== null && _schema$ui !== void 0 && _schema$ui.multipleLine || (_schema$ui2 = schema.ui) !== null && _schema$ui2 !== void 0 && (_schema$ui2 = _schema$ui2.props) !== null && _schema$ui2 !== void 0 && _schema$ui2.multipleLine)
        }
      };
    }
  }]
};